import { CircleTopics } from "./circles/AnyoCircles";

export interface TherapistAppResponseV2 {
    isVisible: boolean;
    id: string;
    name: string;
    qualification: string[];
    expertLevel?: {
      name: string;
      id: string;
    };
    expertise: {
      verticalId: string;
      verticalName: string;
      specializations: {
        name: string;
        id: string;
      }[];
    }[];
    perSessionRate: TherapistCostPerSessionRange;
    videoUrl?: string;
    testimonials?: {
      author: string;
      text: string;
    }[];
    yearsOfExperience: number;
    bio: string;
    languages: string[];
    picture: string;
    rating: number;
    order: number;
    activities?: TherapistAppResponseV2Activities;
    designationLevel: string;
    tagLine?: string;
    title: string;
    slug: string;
    tags: TherapistTags[];
  }

  export enum TherapistTags {
    TEST_THERAPIST = "TEST_THERAPIST",
    EXTERNAL_THERAPIST = "EXTERNAL_THERAPIST",
  }
interface TherapistCostPerSessionRange {
    currency: string;
    currencySymbol: string;
    amount: {
      max: number;
      min: number;
    };
  }

interface TherapistAppResponseV2Activities {
    userInterests: CircleTopics[];
    events: {
      eventId: string;
      name: string;
      eventDate: string;
      category: string;
    }[];
    anyoTalks: {
      id: string;
      name: string;
      nextLiveOn: string | undefined;
    }[];
  }